// QualityFlag を説明文にする。SSR の詳細パネルと一覧のツールチップで共有する。
import type { QualityFlag } from "../../schema/muni";
import { DEFAULT_LANG, type Lang } from "./i18n";

export const FLAG_LABELS: Record<Lang, Record<QualityFlag, string>> = {
  ja: {
    "no-landprice-sample": "地価公示の住宅地標本が無いため中央値を算出できません",
    "inland-no-tsunami": "津波浸水想定区域の指定がありません（内陸、または区域未公表）",
    "hazard-tiles-partial":
      "ハザードタイルの取得率が 99% 未満のため面積比の精度が下がっている可能性があります",
    "temp-mesh-missing": "代表点の気温メッシュが一部欠測です",
    "quake-missing": "J-SHIS が確率値を返さなかったため震度確率は欠測です",
    "population-missing": "人口統計に該当する市区町村の行が無いため人口は欠測です",
    "future-population-missing":
      "将来推計人口に該当する市区町村の行が無いため人口の増減は欠測です（社人研が地域単位でしか推計していない自治体など）",
    "medical-missing": "病院・診療所の数を集計できませんでした（0 か所という意味ではありません）",
    "food-stores-missing": "食料品店数を集計できませんでした（0 店という意味ではありません）",
  },
  en: {
    "no-landprice-sample":
      "No residential sample point in the land price survey, so no median could be computed",
    "inland-no-tsunami": "No tsunami inundation area is designated (inland, or not yet published)",
    "hazard-tiles-partial":
      "Less than 99% of the hazard tiles could be fetched, so the area ratio may be less precise",
    "temp-mesh-missing": "Part of the temperature mesh at the representative point is missing",
    "quake-missing": "J-SHIS returned no probability, so the shaking probability is missing",
    "population-missing": "The census has no row for this municipality, so population is missing",
    "future-population-missing":
      "The population projection has no row for this municipality (some areas are only projected as a region), so the change is missing",
    "medical-missing": "Hospital and clinic counts could not be computed (this does not mean zero)",
    "food-stores-missing": "The food store count could not be computed (this does not mean zero)",
  },
};

export function describeFlags(flags: QualityFlag[], lang: Lang = DEFAULT_LANG): string[] {
  return flags.map((f) => FLAG_LABELS[lang][f]);
}
